import axios from 'axios';

// Instância própria pro catálogo público (/loja/:slug) — de propósito SEM os
// interceptors de services/api.js, que injetam Authorization e redirecionam
// pra /login em qualquer 401. Um visitante anônimo nunca pode ser mandado
// pra tela de login do ERP.
const apiPublico = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
});

export default apiPublico;
